(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("@alifd/next"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "@alifd/next"], factory);
	else if(typeof exports === 'object')
		exports["QzLowcodeComponents"] = factory(require("react"), require("react-dom"), require("@alifd/next"));
	else
		root["QzLowcodeComponents"] = factory(root["React"], root["ReactDOM"], root["Next"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__50__) {
return 